import {isLeft} from 'fp-ts/lib/Either'
import reporter from 'io-ts-reporters'

import {CardActionsCodecV2} from '../common/types'
import {useEnvironmentByOrganisationIdAndIdQuery} from '../data/workbench-api/generated/environment-card-actions'
import {notify} from '../lib/bugsnag'

export const useGetEnvironmentCardActions = (
  environmentId: string,
  organisationid: string
) => {
  const {data, loading} = useEnvironmentByOrganisationIdAndIdQuery({
    variables: {
      environmentId: environmentId,
      organisationId: organisationid
    }
  })

  const environmentCardActionsDecode = CardActionsCodecV2.decode(
    data?.environmentByOrganisationIdAndId?.actionConfiguration
  )
  if (isLeft(environmentCardActionsDecode)) {
    const errors = reporter.report(environmentCardActionsDecode)
    notify('Error loading environment card actions configuration', {
      environmentId,
      organisationid,
      errors
    })
    return {loading, environmentCardActions: undefined, errors}
  }

  return {
    loading,
    environmentCardActions: environmentCardActionsDecode.right
  }
}
